import { ListCustomizer } from '@kinet-open-network/client/core/forms/ui';
import { StockItem } from '@kinet-open-network/client/stock-items/data-access';
import { StockItemsListComponent } from '@kinet-open-network/client/stock-items/feature/list';

export const stockItemsListCustomization: ListCustomizer<
  StockItem,
  StockItemsListComponent
> = (context) => ({
  columns: [
    {
      key: 'prototypeCode',
      label: 'Kód prototypu',
      filter: 'text',
    },
    {
      key: 'serialNumberDevice',
      label: 'Sériové číslo prístroja',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'partnerExtId',
      label: 'ID partnera',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'manufacturer',
      label: 'Výrobca',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'owner',
      label: 'Vlastník',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'shortName',
      label: 'Skrátený názov',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'bottleWeight',
      label: 'Hmotnosť fľaše',
      filter: 'numeric',
      hidden: true,
    },
    {
      key: 'gasWeight',
      label: 'Hmotnosť náplne',
      filter: 'numeric',
      hidden: true,
    },
    {
      key: 'pressureTestDate',
      label: 'Dátum tlakovej skúšky',
      filter: 'date',
      hidden: true,
    },
    {
      key: 'pressureTestExpirationDate',
      label: 'Platnosť tlakovej skúšky',
      filter: 'date',
      hidden: true,
    },
    {
      key: 'isFull',
      label: 'Plná',
      filter: 'boolean',
    },
    {
      key: 'specialWarranty',
      label: 'Špeciálna záruka',
      filter: 'boolean',
      hidden: true,
    },
    {
      key: 'reservationPartner',
      label: 'Partner rezervácie',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'itemOrder',
      label: 'Poradie položky',
      filter: 'numeric',
      hidden: true,
    },
    {
      key: 'nsCode',
      label: 'Kód NS',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'iaCode2',
      label: 'Kód IA2',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'onixBottleSaleSku',
      label: 'ONIX SKU predaj fľaše',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'tags',
      label: 'Tagy',
      filter: {
        type: 'select',
        options: context.tagsStore.options(),
      },
    },
  ],
});
